/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { isNil } from "~/tools";
import { useFormContext } from "../../context";
import { ListItemValue, ListItemValueProps } from "./ListItemValue";

type Props = ListItemValueProps & {
  value: string;
};

export function AccountListItemValue({ value, ...props }: Props) {
  const { accounts, isLoading } = useFormContext();

  // This lookup might cause performance issues,
  // account name could be fetcher from Apollo Api or thanks to the schema modifications
  const account = React.useMemo(
    () => accounts.find((acc) => acc.value === value),
    [accounts, value]
  );

  const itemValue = getLabel(account?.label, value, isLoading);

  return <ListItemValue value={itemValue} {...props} />;
}

function getLabel(
  label: string | undefined,
  value: string,
  isLoading: boolean
) {
  if (isLoading) {
    return "";
  }

  if (label === value || isNil(label)) {
    return value;
  }

  return `${label} (${value})`;
}
